
<template>
  <div class="device-info">
    <h2>Info</h2>
    <template v-if="loading">
      <!--<spinner></spinner>-->
      Loading...
    </template>
    <template v-else>
      <table>
        <tr
          class="info-item"
          v-for="(item, key, counter) in deviceInfo"
          :key="key"
          @click="test"
          :tabindex="counter"
        >
          <td class="key">{{ key }}</td>
          <td>{{ JSON.stringify(item) }}</td>
        </tr>
      </table>
    </template>
  </div>
</template>

<script>
import { keyHandler, KEYS } from '@/mixins/keyHandler';
//import router from '@/router';
import { NAV_TYPE } from '@/store/modules/navigation';
import DeviceType from '@/helpers/DeviceType';
import Device from '../helpers/Device';
import Requests from '@/helpers/Request';
import DeviceFingerprint from '@/helpers/fingerprint';

export default {
  mixins: [keyHandler],
  data() {
    return {
      deviceInfo: {},
      loading: false,
      rows: []
    };
  },
  created() {
    this.getDataFromDevice()
  },
  methods: {
    test(event) {
      event.currentTarget.focus();
      console.log(event.currentTarget);
    },
    hanleRemote(event) {
      console.log('HANDLE REMOTE', event);
    },
    eventHandler(key) {
      switch (key) {
        case KEYS.RED:
          console.log("RED", key);
          break;
        case KEYS.GREEN:
          console.log("GREEN", key);
          break;
        case KEYS.YELLOW:
          this.pushDeviceUpdateToApi();
          break;
        case KEYS.BLUE:
          console.log("BLUE", key);
          break;
        case KEYS.BACK:
        case KEYS.ENTER:
        case KEYS.EXIT:
          this.$store.dispatch('navigation/to', NAV_TYPE.BACK);
          break;
      }
    },
    async pushDeviceUpdateToApi() {
      const deviceId = this.$store.state.device.deviceId;
      const bid = this.$store.state.device.buildingId;
      if (!deviceId || !bid) {
        console.warn('[Info] pushDeviceUpdateToApi: deviceId oder buildingId fehlt');
        return;
      }
      try {
        const [mac, ip, serialNumber, fingerprint, model, version, firmware, platform] = await Promise.all([
          Device.mac,
          Device.ip,
          Device.serialNumber,
          new DeviceFingerprint().generateFingerprint(),
          Device.model,
          Device.version,
          Device.firmware,
          Device.platform,
        ]);
        const data = {
          mac,
          ip,
          serialNumber,
          fingerprint,
          resWidth: Device.resolutionWidth,
          resHeight: Device.resolutionHeight,
          type: DeviceType.getDeviceType,
          agent: DeviceType.getUserAgent,
          model,
          version,
          software: firmware,
          platform,
          updated: Math.floor(new Date().getTime() / 1000),
        };
        console.log('[Info] Device-Update senden:', data);
        await Requests.updateDeviceInfo({ bid, deviceId, data });
      } catch (err) {
        console.error('[Info] Device-Update fehlgeschlagen:', err);
      }
    },
    async getDataFromDevice() {
        this.loading = true;
        this.deviceInfo.mac = await Device.mac;//DeviceType.getMAC
        this.deviceInfo.ip = await Device.ip;//DeviceType.getIP
        this.deviceInfo.serial = await Device.serialNumber;
        this.deviceInfo.DeviceType = DeviceType.getDeviceType;
        const skipProps = new Set(['serialNumber']); // serialNumber wird durch 'serial' ersetzt
        for(const prop in this.$store.state.device) {
          if(skipProps.has(prop)) continue;
          if(this.$store.state.device[prop]) {
            if(typeof this.$store.state.device[prop] === 'function') continue;
            if(typeof this.$store.state.device[prop] === 'object') continue;
            this.deviceInfo[prop] = this.$store.state.device[prop];
          }
        }
        for(const prop in navigator) {
          // console.log(prop, navigator[prop]);
          if(navigator[prop]) {
            if(typeof navigator[prop] === 'function') continue;
            if(typeof navigator[prop] === 'object') continue;
            // if (typeof navigator[prop] === 'object') {
            //   if (!Object.keys(navigator[prop]).length) {
            //     continue;
            //   }
            // }
            this.deviceInfo[prop] = navigator[prop];
          }
        }
        console.log("===============deviceInfo", this.deviceInfo);
        this.loading = false;
        /*
        (async () => {
          console.log('---------------MAC   :', await Device.mac);
          console.log('---------------IP    :', await Device.ip);
          console.log('---------------SERIAL:', await Device.serialNumber);
          return Device.ip;
        })()
        .then(response => {
          this.loading = false
          this.rows = response
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        })

        */
    },
  },
  computed: {},
  watch: {},
  mounted() {
    /* eslint-disable */
    console.log('======================================here', navigator, window.navigator);
    console.log("======================================INFO-deviceStat:", this.$store.state.device);
    if(!navigator) return;
    //console.log("=====LENGTH", typeof navigator, Object.keys(navigator).length);
    //this.deviceInfo.width = window.innerWidth;
    //this.deviceInfo.height = window.innerHeight;
    //this.deviceInfo.tizenVersion = Device.tizenVersion;
    //console.log("======================================INFO-deviceStat:", this.$store.state.device);
  },
};
</script>

<style scoped>
.device-info {
  background-color: red;
  height: 100%;
  padding: 1%;
}
.key {
  font-weight: bold;
  padding-right: 1rem;
}
h2 {
  font-size: x-large;
  font-weight: 700;
  margin: 0 1rem 1rem;
}
table {
  border-collapse: collapse;
  margin: 0 1rem;
}
td {
  padding: 0.2rem 0;
}
.info-item {
  border-bottom: 1px solid black;
}
.video-test {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/Info.vue